import React from "react";
import {useDispatch, useSelector} from "react-redux";

import {optionAction} from "../../../../redux/store";
import {useColorTargets} from "../../../../hooks/controller/useColorTargets";
import ColorChipList from "./ColorChipList";
import {loadDataAndSet} from "../../../../redux/optionWindow-slice/optionWindowSlice";


const ColorTab = ({code, colorByCategory, codeKeyData, colorItemObject}) => {
  const dispatch = useDispatch();
  const langData = useSelector(state => state.theme.langData);
  const configData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const colorCategory = colorItemObject?.colorCategories;
  const isSingle = colorItemObject?.isSingle;
  const categoriesExcludingDefault = colorCategory && colorCategory.filter(item => !item.nameEn.includes("default")) || [];
  const defaultCategory = colorCategory && colorCategory.find(item => item.nameEn.includes("default"));

  const colorTargets = useColorTargets(isSingle, colorItemObject)


  const handleSingleColorSelect = (item) => {
    const targetsConfigData = configData[code];
    const {CUSTOM, ...rest} = targetsConfigData || {};

    const payload = {
      key: code,
      value: {
        ...rest,
        COLOR: item.color.code,
        DIFFUSE: item.color.diffRgb,
        ...(targetsConfigData?.CODE && { COLORNAME: item[langData.langName] }),
      }
    };

    if(item.color.type === "EXT") {
      payload.value.MATERIAL = item.color.materialType.toUpperCase();
    }
    dispatch(optionAction.setSendData(payload));
  };


  const handleGroupColorSelect = (item) => {
    const copyConfigData = {...configData};

    for (let colorTarget of colorTargets) {
      const targetsConfigData = copyConfigData[colorTarget];
      const {CUSTOM, ...rest} = targetsConfigData || {};

      copyConfigData[colorTarget] = {
        ...rest,
        COLOR: item.color.code,
        DIFFUSE: item.color.diffRgb
      }
    }

    dispatch(loadDataAndSet({
      processedData: copyConfigData,
      colorway: copyConfigData.COLORWAY
    }));
  };



  const colorChipSelectHandler = (item) => {
    if (colorTargets.length === 0) {
      handleSingleColorSelect(item);
    } else {
      handleGroupColorSelect(item);
    }
  };



  const renderColorChips = () => {
    if (!colorItemObject) return null;

    // paletteId가 있는 경우
    if (colorItemObject.paletteId) {
      if (categoriesExcludingDefault.length > 0) {
        return categoriesExcludingDefault
          .sort((a, b) => a.categoryOrder - b.categoryOrder)
          .map((category, idx) => {
            if (colorByCategory[category.id]) {
              return (
                <ColorChipList
                  key={idx}
                  categoryName={category[langData.langName]}
                  colorArray={colorByCategory[category.id]}
                  codeKeyData={codeKeyData}
                  colorChipSelectHandler={colorChipSelectHandler}
                />
              );
            }
            return null;
          });
      }

      return (
        <ColorChipList
          categoryName={""}
          colorArray={colorByCategory[defaultCategory?.id]}
          codeKeyData={codeKeyData}
          colorChipSelectHandler={colorChipSelectHandler}
        />
      );
    }

    // paletteId가 없는 경우
    if (colorCategory?.length > 0) {
      return [...colorCategory]
        .sort((a, b) => a.categoryOrder - b.categoryOrder)
        .map((category, idx) => {
          if (colorByCategory[category.id]) {
            return (
              <ColorChipList
                key={idx}
                categoryName={category[langData.langName]}
                colorArray={colorByCategory[category.id]}
                codeKeyData={codeKeyData}
                colorChipSelectHandler={colorChipSelectHandler}
              />
            );
          }
          return null;
        });
    }

    return (
      <ColorChipList
        categoryName={""}
        colorArray={colorByCategory["default"]}
        codeKeyData={codeKeyData}
        colorChipSelectHandler={colorChipSelectHandler}
      />
    );
  };


  return (
    <>
      {colorItemObject && (
        <div className={"tab-content active color-tab"}>
          {renderColorChips()}
        </div>
      )}
    </>
  )
}

export default ColorTab;
